import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import InputField from '../../../../reusable-components/InputField';
import { required, compare_password, passwordMinLength, alphanumeric } from '../../../../utils/validations';
import Spinner from '../../../../reusable-components/Spinner';
import PageContent from '../../../../reusable-components/ActivatePageContent';
import PageHeader from '../../../../reusable-components/ActivatePageHeader';
import PropTypes from 'prop-types';

class ResetPasswordForm extends Component {
  constructor(props){
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values){
    const { changePassword, history } = this.props;
    const { password } = values;
    changePassword({ password }, history);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user !== prevProps.user) {
      this.props.history.push('/step/two');
    }
  }

  render() {
    const { 
      handleSubmit, 
      pristine, 
      submitting, 
      isloading, 
      error,
      error_message } = this.props;

    let buttonState = null;

    buttonState = isloading ? <Spinner /> : "Doorgaan";

    return (
      <>
        <PageHeader title="Wachtwoord Instellen" />
        <PageContent 
          title="Wachtwoord Instellen"
          goBack={() => this.props.history.goBack()}
          moveNext={() => {}}
          cardClass="card-container"
          showFooter={true}
          hasSubmitBtn={true}
          hasBackBtn={true}
          formClassNames=""
          buttonState={isloading}
          submitting={submitting}
          errors={error_message}
          btnDisabled={pristine || submitting}
          handleSubmit={handleSubmit(this.onSubmit)}>
        <div className="form-container custom-container">
          <Row>
            <Col sm={12} md={6}>
              <p><span>Keis een veilig wachtwoord Het wachtwoord heeft <br/> u nodig om in te loggen in uw account</span></p>
            </Col>
            <Col sm={12} md={6}>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <Field
                    required
                    type="password"
                    name="password"
                    label="Wachtwoord"
                    component={InputField}
                    validate={[required, passwordMinLength, alphanumeric]}
                  />
                </div>
                <div className="form-group col-md-12">
                  <Field
                    required
                    type="password"
                    name="confirm_password"
                    label="Bevestig Wachtwoord"
                    component={InputField}
                    validate={[required, compare_password, passwordMinLength, alphanumeric]}
                  />
                </div>
              </div>
            </Col>
            {/*<div className="content-footer">
              <button 
                type="button" 
                className="btn back-btn"
                onClick={() => {
                  this.props.history.goBack();
                }}>
                Terug
              </button>
              <button type="submit" className="btn continue-btn" disabled={pristine || submitting}>
                {buttonState}
              </button>
            </div>*/}
          </Row>
        </div>
        </PageContent>
      </>
    );
  }
}

ResetPasswordForm.propTypes = {
  isloading: PropTypes.bool,
  error_message: PropTypes.string,
  formErrors: PropTypes.object
}

const ResetPasswordComponent = reduxForm({
  form: 'reset-password-form'
})(ResetPasswordForm);

export default ResetPasswordComponent;

